export const styles = {
    paymentForm: {
      maxWidth: '550px',
      width: '100%',
      margin: '0 auto',
      padding: '20px',
      marginTop: '-50px'
    },
    description: {
      color: '#000',
      fontSize: '20px',
      '@media (max-width: 480px)': {
        fontSize: '14px',
      },
    },
    formGroup: {
      marginBottom: '15px',
    },
    input: {
      width: '100%',
      border: '1px solid #d3d3d3',
      padding: '8px',
      borderRadius: '4px',
    },
    flexContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '10px',
      '@media (max-width: 480px)': {
        flexDirection: 'column',
        gap: '15px',
      },
    },
    cityInput: {
      width: '48%',
      '@media (max-width: 480px)': {
        width: '100%',
      },
    },
    button: {
      width: '100%',
      borderRadius: '10px',
    },
    saveButton: {
      marginBottom: '15px',
      width: '100%',
      backgroundColor: '#ff007f',
      borderColor: '#ff007f',
    },
    modalButton: {
      width: '100%',
      marginBottom: '10px',
    },
    labelStyle: {
        color: '#233658',
        fontSize: '24px',
        fontWeight: '600'
    }
  };